import { render } from "./chat.vue?vue&type=template&id=cb9185f0&scoped=true"
import script from "./chat.vue?vue&type=script&lang=ts"
export * from "./chat.vue?vue&type=script&lang=ts"

import "./chat.vue?vue&type=style&index=0&id=cb9185f0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb9185f0"

export default script